<template>
  <div v-if="!load">
    <Navbar2 :informasiDasar="informasiDasar" />
    <section class=" pt-16 md:pt-36">
      <div class="flex justify-center">
        <span class="bg-btn-blue/30 text-biru py-1 px-5 text-xs rounded-full">{{ $t('message.berita') }}</span>
      </div>
      <div class="w-full md:px-36 py-7 md:py-10">
        <div class="bg-white rounded-lg shadow-tabungan p-7">
          <h1 class="text-biru text-lg font-semibold">{{ $i18n.locale == "id" ? item.judul : item.judul_en }}</h1>
          <div v-if="item?.tgl_posting" class="text-xs text-abumaluku">
            {{
              $i18n.locale == "id" ? new Intl.DateTimeFormat("id", {
                dateStyle: "full", timeStyle: "short"
              }).format(new Date(item.tgl_posting)) : new Intl.DateTimeFormat("en-US", {
                dateStyle: "full", timeStyle:
                  "short"
              }).format(new Date(item.tgl_posting))
            }}
          </div>
          <img :src="`${$baseUrl}/berita/${item.foto}`" class="object-cover my-2 w-full" alt="" />
          <div v-html="$i18n.locale == 'id' ? item.isi : item.isi_en"></div>
        </div>
      </div>
      <!-- <div class="px-7 md:px-36 py-7 md:py-10 space-y-4"> -->
      <!-- <div class="grid grid-cols-12 gap-10 w-full"> -->
      <!-- <div class="col-span-12 md:col-span-8 bg-white rounded-lg shadow-tabungan">
              ok
          </div> -->
      <!-- <div class="col-span-12 md:col-span-4">tes</div> -->
      <!-- </div> -->
      <!-- </div> -->
    </section>
    <Footer :informasiDasar="informasiDasar" />
  </div>
</template>

<script>
import Navbar2 from "../Navbarv2.vue";
import Footer from "../Footer.vue";
import Tender from "./sections/Tender.vue";
import BeritaHalamanVue from "./sections/BeritaHalaman.vue";
import { getInformasiDasar, getBeritaById } from "@/api/LandingPageApi";
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import handlePagination from "@/views/components/handlePagination";
import { useRoute } from "vue-router";

export default {
  components: {
    Navbar2,
    Footer,
    BeritaHalamanVue,
    Tender,
  },
  setup() {
    const load = ref(false);
    const informasiDasar = ref({});
    const item = ref({});
    const route = useRoute();
    onMounted(async () => {
      load.value = true;
      getInformasi();
      getData();
      load.value = false;
    });

    const getInformasi = async () => {
      const result = await getInformasiDasar();
      if (result?.data?.data) informasiDasar.value = result.data.data;
    };

    const getData = async () => {
      const result = await getBeritaById(route.params.id);
      if (result?.data?.data) item.value = result.data.data;
    };

    return { informasiDasar, load, item };
  },
};
</script>

<style scoped>
:deep() .gradient-malut {
  background: linear-gradient(119.36deg, #f6fcff 15.13%, rgba(247, 249, 255, 0.711489) 36.6%, rgba(255, 255, 255, 0) 89.54%);
}
</style>
